import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-promotions/promotions/${formData.promotionId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-promotions/promotions/${formData.promotionId}`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-promotions/${id}`);
  },
};
